import ResultsServiceCollection from '../ResultsServiceCollection'
import SampleResultModel from '../../models/result/SampleResultModel'

/**
 * Sample Result collection
 */
export default class SampleResultCollection extends ResultsServiceCollection {

  // Model that is contained in this collection.
  model () {
    return SampleResultModel
  }

  getModelsFromResponse (response) {
    const models = []
    const { data } = response.getData()

    if (data.pagination) {
      this.set('count', data.pagination.total)
    }

    if (data.sample_results) {
      data.sample_results.forEach((insert) => {
        const temp = (new (this.model())(insert))
        models.push(temp)
      })
    }

    return models
  }

}
